document.addEventListener('DOMContentLoaded', () => {
  /**
   * @param input
   */
  function checkQuantity(input) {
    const decrease = input.closest('.quantity-input').querySelector('.product__quantity-subtract-item');
    if (input.value === '1') {
      if (!decrease.classList.contains('disabled')) {
        decrease.classList.add('disabled');
      }
    } else {
      decrease.classList.remove('disabled');
    }
  }

  /**
   *
   */
  function checkingQuantityAllInputs() {
    const quantitiyInputs = document.querySelectorAll('.quantity-input__input');
    if (quantitiyInputs) {
      quantitiyInputs.forEach((input) => {
        checkQuantity(input);
        input.addEventListener('change', () => {
          checkQuantity(input);
        });
      });
    }
  }

  checkingQuantityAllInputs();

  // eslint-disable-next-line func-names
  document.addEventListener('quickview:loaded', function () {
    checkingQuantityAllInputs();
  });

  // eslint-disable-next-line func-names
  document.addEventListener('quick-cart:open', function () {
    checkingQuantityAllInputs();
  });
});
